import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _headings;

import { ModalHeader } from '../styles';
import React from 'react';
import { OnboardingType } from '../types';
var headings = (_headings = {}, _defineProperty(_headings, OnboardingType.none, 'Do more with Chegg® Study Pack'), _defineProperty(_headings, OnboardingType.megaMenu, 'Do more with Chegg® Study Pack'), _defineProperty(_headings, OnboardingType.megaMenuLive, 'Do more with Chegg® Study Pack Live'), _defineProperty(_headings, OnboardingType.slider, 'Welcome to Chegg® Study Pack'), _defineProperty(_headings, OnboardingType.sliderLive, /*#__PURE__*/React.createElement(React.Fragment, null, "Welcome to", /*#__PURE__*/React.createElement("br", null), " Chegg\xAE Study Pack Live!")), _headings);
export var OnboardingHeading = function OnboardingHeading(_ref) {
  var onboardingType = _ref.onboardingType,
      offset = _ref.offset,
      dataTest = _ref['data-test'];
  return /*#__PURE__*/React.createElement(ModalHeader, {
    offset: offset,
    "data-test": dataTest
  }, headings[onboardingType]);
};